'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { assetConfirm } from '@xdocs/i18n';
import { useI18n } from '../../i18n/LocaleProvider.js';
import { Button } from '../../primitives/Button/Button.js';
import { Modal } from '../Modal/Modal.js';
import styles from './ConfirmDialog.module.css';
/**
 * Named-asset destructive/blocking confirm (CODE_GUIDELINES §16.1,
 * CLAUDE_DESIGN.md §3.3). Composes `assetConfirm` (the ONE builder that
 * makes a generic "Delete this?" confirm impossible to write) with `Modal`.
 */
export function ConfirmDialog({ open, onOpenChange, action, assetName, destructive = false, onConfirm, loading = false, error, }) {
    const { t, locale } = useI18n();
    const [submitting, setSubmitting] = useState(false);
    const confirm = assetConfirm(locale, action, assetName, { destructive });
    const isBusy = loading || submitting;
    async function handleConfirm() {
        setSubmitting(true);
        try {
            await onConfirm();
        }
        finally {
            setSubmitting(false);
        }
    }
    return (_jsxs(Modal, { open: open, onClose: () => onOpenChange(false), title: action, size: "sm", children: [_jsx("p", { className: styles['message'], children: confirm.message }), error && (_jsx("p", { role: "alert", className: styles['error'], children: error })), _jsxs("div", { className: styles['actions'], children: [_jsx(Button, { variant: "secondary", onClick: () => onOpenChange(false), disabled: isBusy, children: t('common:action.cancel') }), _jsx(Button, { variant: destructive ? 'destructive' : 'primary', state: isBusy ? 'loading' : 'idle', onClick: () => void handleConfirm(), children: action })] })] }));
}
